// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3_L7_","name":"ConsentHeader_name__30pt-","birthday":"ConsentHeader_birthday__3veCD","skeleton":"ConsentHeader_skeleton__2Lda5"};